import React from "react";
import { IUserStatusModel } from "../interface";
import { AppRegistration, InstallMobileOutlined, Money, Person, Subscriptions, TranscribeOutlined, VerifiedUser } from '@mui/icons-material';
import { Avatar, Box, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import '../UserProgress.css'
import FormServices from "../../../Services/FormServices";
import { ShowBlocker } from "../../../Components/LoaderComponent/LoaderComponent";
export interface UserJourneyStepModel {
  label: string;
  description: string;
  icon: any;
  isCompleted: boolean;
}

type State = {
  steps: UserJourneyStepModel[];
};

type Props = {
  detail: IUserStatusModel;
  accessToken: string;
};
class ViewUserProgress extends React.Component<Props, State> {
  userProgress: IUserStatusModel | null = null;
  constructor(props_: Props) {
    super(props_);
    this.userProgress = props_.detail;
    let docusignPending = `Pending to fill form details and complete the digital signature`;
    let docusignCompleted = `Form completed and digitally signed.`;
    let irsSubmissionPending = `Pending Form 8821 Submission to IRS`;
    let irsApprovalPending = `Pending with IRS for approval`;
    let irsApproved = `IRS Approved the form`
    this.state = {
      steps: [
        {
          label: 'Registration',
          description: 'Completed mobile verification',
          icon: <AppRegistration />,
          isCompleted: true
        },
        {
          label: 'ID Verification',
          description: this.userProgress.isPersonaCompleted ? 'Completed government ID verification' : `Pending to complete ID verification`,
          icon: <VerifiedUser color={this.userProgress.isPersonaCompleted ? "primary" : "disabled"} />,
          isCompleted: this.userProgress.isPersonaCompleted
        },
        ...(this.userProgress.accountType == 1
          ? [{
            label: 'Subscription',
            description: this.userProgress.isSubscriptionCompleted ? `Subscription completed` : `Pending to complete subscription`,
            icon: <Subscriptions color={this.userProgress.isSubscriptionCompleted ? "primary" : "disabled"} />,
            isCompleted: this.userProgress.isSubscriptionCompleted
          }]
          : []),
        {
          label: 'Sign-in Authorization',
          description: !this.userProgress.form8821Docusign ? docusignPending : !this.userProgress.isForm8821Submitted && !this.userProgress.isForm8821Approved ? irsSubmissionPending : !this.userProgress.isForm8821Approved ? irsApprovalPending : irsApproved,
          icon: <TranscribeOutlined color={this.userProgress.isForm8821Approved ? "primary" : "disabled"} />,
          isCompleted: this.userProgress.isForm8821Approved
        },
        ...(this.userProgress.accountType == 1
          ? [{
            label: 'Financials',
            description: 'Integrated Financial details to EASALY AI',
            icon: <TranscribeOutlined color={this.userProgress.isFinancialsCompleted ? "primary" : "disabled"} />,
            isCompleted: this.userProgress.isFinancialsCompleted
          },
          {
            label: `Financial's Form`,
            description: !this.userProgress.form433ADocusign ? docusignPending : !this.userProgress.isForm433ASubmitted ? docusignCompleted : '',
            icon: <Money color={this.userProgress.form433ADocusign ? "primary" : "disabled"} />,
            isCompleted: this.userProgress.form433ADocusign
          },
          {
            label: 'Choose Payment Plan',
            description: !this.userProgress.form433DDocusign ? docusignPending : !this.userProgress.isForm433DSubmitted ? irsSubmissionPending : !this.userProgress.isForm433DApproved ? irsApprovalPending : irsApproved,
            icon: <InstallMobileOutlined color={this.userProgress.isForm433DApproved ? "primary" : "disabled"} />,
            isCompleted: this.userProgress.isForm433DApproved
          }
          ]
          : [{
            label: 'One-time service fee payment',
            description: this.userProgress.isKwongPaymentCompleted ? `One-time service fee payment completed` : `One-time service fee payment pending`,
            icon: <Subscriptions color={this.userProgress.isKwongPaymentCompleted ? "primary" : "disabled"} />,
            isCompleted: this.userProgress.isKwongPaymentCompleted
          }])]
    }
  }

  /**
     * Below function download the form-8821 of the user 
     * @param row - respective row details for which the download button is clicked
     */
  private async downloadForm(body: any, isTaxPayer = true) {

    try {
      // const body = {
      //     envelopeId: isTaxPayer ? this.state.formStepper.envelopeId : this.state.form8821.nonTaxpayer.envelopeId,
      //     isSubmittedtoIRS: isTaxPayer ? this.state.formStepper.submittedToIrs : this.state.form8821.nonTaxpayer.isSubmittedToIRS,
      //     formType: formType
      // };
      FormServices.downloadDocusignedPDF(body, this.props.accessToken).then((r) => {
        if (r.ok) {
          r.json().then((response) => {

            const byteCharacters = atob(response.body);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], { type: response.headers['Content-Type'] });

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${this.userProgress?.email}_${body.formType}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

          });
        }
      });

    } catch (error: any) {
      console.error('Error downloading the file:', error.response?.data || error.message);
      ShowBlocker(false);

    }

  }

  private viewDownload(label: string) {
    try {
      let element;
      switch (label) {
        case 'Sign-in Authorization':
          element = this.userProgress?.form8821Docusign ?
            <button className="download-form-Btn" onClick={
              async () => {
                let body = {
                  envelopeId: this.userProgress?.form8821EnvelopeId,
                  isSubmittedtoIRS: 0,
                  formType: 'form-8821'
                };
                this.downloadForm(body);
              }
            }>Download Form 8821</button> : '';
          break;
        case `Financial's Form`:
          element = this.userProgress?.form433ADocusign ?
            <button className="download-form-Btn" onClick={
              async () => {
                let body = {
                  envelopeId: this.userProgress?.form433AEnvelopeId,
                  isSubmittedtoIRS: 0,
                  formType: 'form-433A'
                };
                this.downloadForm(body);
              }
            }>Download Form 433-A</button> : '';
          break;
        case `Installment - Form 433-D`:
          element = this.userProgress?.form433DDocusign ?
            <button className="download-form-Btn" onClick={
              async () => {
                let body = {
                  envelopeId: this.userProgress?.form433DEnvelopeId,
                  isSubmittedtoIRS: 0,
                  formType: 'form-433D'
                };
                this.downloadForm(body);
              }
            }>Download Form 433-D</button> : '';
          break;
      }
      return element;
    }
    catch (ex) {
      throw ex;
    }
  }

  render() {
    const { steps } = this.state;

    return (
      <Box sx={{ maxWidth: 500 }}>
        <Stepper orientation="vertical" nonLinear>
          {steps.map((step, index) => (
            <Step key={index} active={true} completed={step.isCompleted}>
              <StepLabel
                sx={{
                  fontSize: '16px'
                }}
                icon={
                  step.icon
                }
              >
                {step.label}
              </StepLabel>
              <StepContent sx={{
                textAlign: 'left',
                fontSize: '10px !important'
              }}>
                <Typography className={step.label == 'Sign-in Authorization' &&
                  (!this.userProgress?.isForm8821Approved && this.userProgress?.form8821Docusign && (!this.userProgress?.isForm8821Submitted) ||
                    this.userProgress?.form8821ResubFlag) ? 'form-error' : ''}>{step.description}</Typography>
                <Typography>
                  {this.viewDownload(step.label)}
                </Typography>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>
    );
  }
}

export default ViewUserProgress;